<template>
  <!-- {{ props.terrID }} -->
  <div id="mapContainer"
    :style="{
      'height': !screen.isMobile ? '100vh' : '60vh'
    }"
  ></div>
</template>

<script setup>
import {
  onMounted,
  defineProps,
  defineEmits,
  defineExpose,
  computed,
} from "vue";
import { useMapStore } from "@/store/map";
import { useScreenStore } from "@/store/useScreenStore";

const screen = useScreenStore();
const m = useMapStore();
const props = defineProps({
  center: {
    type: Array,
    default: null,
  },
  terrID: {
    type: String,
    default: null,
  },
  color: {
    type: Object,
    default: null,
  },
  saveCenter: {
    type: Boolean,
    default: true,
  },
  setPoint: {
    type: Boolean,
    default: false,
  },
});

defineExpose({ m });

const center = computed({
  get() {
    console.log("props.center", props.center, m.getStoreCenter());
    return props.center || m.getStoreCenter();
  },
  set(val) {
    // m.$patch({center: val})
  },
});

const emit = defineEmits([
  "mapClick",
  "mapMoveend",
  "mapMoveend",
  "zoomstart",
  "zoomend",
  "ready",
]);

onMounted(() => {
  let service = m.L.map("mapContainer", {
    scrollWheelZoom: false,
    zoomSnap: 0.25,
    zoomAnimation: false,
  }).setView(center.value, 17);
  m.setMap(service);
  m.setTileLayer();
  m.map.value.on("click", function (e) {
    emit("mapClick", e);
  });
  var keydown = false;
  m.map.value.on("keydown", function (e) {
    if (keydown) return;
    keydown = true;
    m.map.value.scrollWheelZoom.enable();
  });
  m.map.value.on("keyup", function (e) {
    keydown = false;
    m.map.value.scrollWheelZoom.disable();
  });
  m.map.value.on("moveend", function (e) {
    emit("mapMoveend", e);
    let data = m.map.value.getBounds().getCenter();
    // console.log(data)
    if (props.saveCenter) center.value = [data.lat, data.lng];
  });

  emit("ready", {
    m: () => m,
    map: () => m.map.value,
  });
});
</script>

<style scoped>
#mapContainer {
  width: 100%;
}
</style>
